const pricingPlans = [
  {
    id: 1,
    name: "Basic Plan",
    days: "Monthly",
    price: 30,
    period: "Weekly",
    sessions: "8 Classes/Month",
    duration: "30 Minutes/Live Session",
    features: [
      "Qualified Quran teacher",
      "Tajweed classes",
      "Access to recorded assessments",
      "Flexible class timings",
      "Progress tracking",
      "One to One Live Class",
      "Time On Your Choice",
      
    ],
    color: "blue"
  },
  {
    id: 2,
    name: "Standard Plan",
    days: "Monthly",
    price: 35,
    period: "Monthly",
    sessions: "12 Classes/Month",
    duration: "30 Minutes/Live Session",
    features: [
      "Certified Quran teacher",
      "Tajweed and basic memorization",
      "Recorded assessments",
      "Learning materials",
      "Flexible scheduling",
      "Monthly progress report",
      "Homework and practice",
      "One to One Live Class"
    ],
    color: "emerald"
  },
  {
    id: 3,
    name: "Advanced Plan",
    days: "Monthly",
    price: 50,
    period: "Monthly",
    sessions: "16 Classes/Month",
    duration: "30 Minutes/Live Session",
    features: [
      "Quran teacher specializing in Tajweed",
      "E-books and learning materials",
      "Recorded assessments",
      "Monthly test",
      "Flexible scheduling",
      "Learning Islamic prayers and duas",
      "Homework and practice",
      "Quran memorization (Hifz)"
    ],
    color: "purple"
  },
  {
    id: 4,
    name: "Premium Plan",
    days: "Monthly",
    price: 65,
    period: "Monthly",
    sessions: "20 Classes/Month",
    duration: "30 Minutes/Live Session",
    features: [
      "Highly qualified Quran teacher",
      "Quran memorization (Hifz)",
      "Tajweed, Tafseer, and Islamic Studies",
      "E-books and personalized notes",
      "Bi-weekly tests",
      "Flexible scheduling",
      "24/7 online support",
      "Completion certificates",
      "Zoom | Team | Whatsapp"
    ],
    color: "amber"
  },
  {
    id: 5,
    name: "Weekend Plan",
    days: "Weekly",
    price: 50,
    period: "Monthly",
    sessions: "8 Classes/Month",
    duration: "30 Minutes/Live Session",
    features: [
      "Qualified Quran teacher",
      "Tajweed classes",
      "Flexible class timings",
      "Progress tracking"
    ],
    color: "blue"
  }
];

export default pricingPlans;
